import styled from "styled-components";

const ApplicationErrorFallback = () => (
  <StyledApplicationErrorFallback>
    <h2 className="error-title">Application error</h2>
    <p className="error-message">Try clearing the cache and refreshing the page</p>
  </StyledApplicationErrorFallback>
);

const StyledApplicationErrorFallback = styled.section`
  font-family: "TT Norms Pro", TTNormsPro, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 1rem;
  height: 100vh;
  text-align: center;
  text-wrap: balance;
  background:
    url("/images/noise.png"),
    radial-gradient(
      69.09% 115.97% at 100% 115.97%,
      rgb(126 100 251 / 75%) 14.44%,
      rgb(255 205 133 / 75%) 59.75%,
      rgb(246 243 241 / 0%) 100%
    ),
    linear-gradient(0deg, #faf7f4, #faf7f4),
    radial-gradient(
        92.25% 102.37% at 108.46% 114.67%,
        rgb(7 64 78 / 75%) 0%,
        rgb(192 221 214 / 75%) 59.75%,
        rgb(246 243 241 / 0%) 100%
      )
      #faf7f4;
  background-blend-mode: overlay, normal, normal, overlay, normal, normal;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .error-title {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }
  }

  .error-message {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: -0.006em;
  }
`;

export { ApplicationErrorFallback };
